import { TicketService } from './../../../services/ticket.service';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ssApiService } from '../../../services/ss-api.service';
import { GlobalService } from '../../../services/global.service';
import { CustomTicketItem, TicketStatusTypes } from '../../../models/domain/custom.ticket.item';
import { CustomTicketWidgetItemArray, CustomTicketWidgetItem } from '../../../models/domain/custom.ticket.widget';
import { TicketDetailsDialog } from '../../../dialogs/ticket.details/ticket.details.dialog';
import { DialogService } from '../../../services/modal-dialogs';
import { MenuItem } from 'primeng/primeng';
import { WindowService } from '../../../../app/services/window-dialogs/window.service';
import { TicketWindowTypes, TicketWindowData } from '../../../dialog-windows/ticket/ticket.window';
import { Router } from '../../../../../node_modules/@angular/router';
import { WindowSettings } from '../../../services/window-dialogs/window.settings';
import { WindowTypes, WindowActionTypes } from '../../../services/window-dialogs/window.event';
import { CustomTicketsWidgetsSearchRequest } from '@models/ss-api/requests/custom.tickets.widgets.search.request';

export enum WidgetTypes {
    Own = 0,
    Unclaimed = 1,
    Member = 2
}

@Component({
    selector: 'ticket-list',
    templateUrl: './ticket.list.component.html',
    styleUrls: ['./ticket.list.component.css']
})
export class TicketListComponent implements OnInit, OnDestroy {

    @Input('Title') Title: string = '';

    IsBusy: boolean = false;

    TicketLoadError: string = '';
    TodaysDate: Date = new Date();

    // inputs
    @Input('WidgetsType') WidgetsType: WidgetTypes = WidgetTypes.Own;
    @Input('MemberID') MemberID: number = 0;
    @Input('AdminID') AdminID: number = 0;
    @Input('IncludeClosed') IncludeClosed: boolean = false;

    @Input('TicketWidgets') Widgets: CustomTicketWidgetItemArray = new CustomTicketWidgetItemArray();
    @Input('TicketFilter') TicketFilter: String;

    draggedWidget: CustomTicketWidgetItem;

    @Input('ShowNew') ShowNew: boolean = true;
    @Input('ShowInProgress') ShowInProgress: boolean = true;
    @Input('ShowAwaitingMember') ShowAwaitingMember: boolean = true;
    @Input('ShowAwaitingAdmin') ShowAwaitingAdmin: boolean = true;
    @Input('ShowTOS') ShowTOS: boolean = true;

    @Input('ShowClosed') ShowClosed: boolean = false;
    @Input('DynamicallyLoadClosed') DynamicallyLoadClosed: boolean = false;
    @Input('StartDate') StartDate: Date = new Date();
    @Input('EndDate') EndDate: Date = new Date();
    @Input('SelectedDateSearchOption') SelectedDateSearchOption: number = 1;
    @Input('HideClosedOption') HideClosedOption: boolean = false;

    @Input('ScrollPanel') ScrollPanel: boolean = false;

    showFilters: boolean = false;
    showOptions: boolean = false;

    EverShowClosed: boolean = false;

    TicketFilterArray: TicketStatusTypes[] = [];

    @Input('showListViewOptions') showListViewOptions: boolean = true;
    @Input('isListView') isListView: boolean = false;

    @Output('ListViewChanged') ListViewChanged = new EventEmitter<Boolean>();

    @Output('onRefresh') onRefresh = new EventEmitter<boolean>();

    @Output('onClosedFilterChanged') onClosedFilterChanged = new EventEmitter<boolean>();

    // private
    private IgnoreWidgetHeigtsList = new Array<string>();


    filterMenuItems: MenuItem[];

    constructor(private api: ssApiService,
        private gb: GlobalService,
        private dialogService: DialogService,
        private windowService: WindowService,
        private router: Router,
        private ticketService: TicketService) {

    }



    ngOnInit() {
        // this.SortTickets();
        this.UpdateFilterArray();
    }

    SortTickets() {
        if (this.Widgets) {
            this.Widgets = this.Widgets.sort((left, right) => {
                if (new Date(left.DueDate) < new Date(right.DueDate)) {
                    return -1;
                } else {
                    return 1;
                }
            })
        }
    }

    onMemberClick(id: number) {
        this.router.navigate(['/member-profile', id]);
    }

    SetUpMenuItems() {
        this.filterMenuItems = [
            { label: '' }
        ];
    }

    applyDetectChanges() {
        this.applyWidgetClasses();
    }


    applyWidgetClasses() {
        // get element for id names
        let divs = document.getElementsByClassName('ticketName');
        if (divs == undefined)
            return;

        // loop through elements to get the html element based on ID
        for (let i = 0; i < divs.length; i++) {

            let id = divs.item(i).id;
            this.applyWidgetClassesSingleByID(id);

        }

    }

    applyWidgetClassesSingleByID(id: string) {

        let item = document.getElementById(id);

        if (item == undefined)
            return;

        if (item.offsetHeight > 20) {
            ////console.log(id + " -> marquee");
            item.className += ' marquee';
        }

    }

    checkLast(item: CustomTicketWidgetItem) {

        if (item.TicketID == this.Widgets[this.Widgets.length - 1].TicketID) {
            ////console.log("ready");
            this.applyWidgetClasses();
        }

    }



    ngOnDestroy() {
    }

    public RefreshWidgets() {
        if (this.WidgetsType == WidgetTypes.Own)
            // this.Widgets = this.Ticketing.WidgetsOwn();
            return
        else
            // this.Widgets = this.Ticketing.WidgetsUnclaimed();
            return
    }

    openTicketDetailsDialog(item: CustomTicketItem) {

        let type = TicketWindowTypes.Internal;

        if (!item.IsInternal) {
            type = TicketWindowTypes.Member;
        }

        console.log("Ticket Load: ", item);
        
        let disposable = this.dialogService.addDialog(TicketDetailsDialog, {
            TicketID: item.TicketID,
            TicketWindowType: type,
            MemberID: item.MemberID
        }, { width: 1100, height: 800 }).subscribe(response => {
            this.onRefresh.emit(true);
            disposable.unsubscribe();
        })

    }

    addNewTicketDialog() {

    }

    LeadPrefix(item: CustomTicketItem): string {

        if (item.MemberID == 0) {
            return '(L) ';
        } else {
            return '';
        }

    }



    ticketNameLengthToDuration(str: string): string {

        let myNumber = str.length;
        myNumber = myNumber / 10;
        if (myNumber < 2)
            myNumber = 2;

        return myNumber + 's';
    }



    ticketDragStart(widget: CustomTicketWidgetItem) {
        this.gb.DraggedTicket = widget;
        $('.TicketWidget' + widget.TicketID).addClass('beingDragged');
        $('body').addClass('draggingTicket');
    }

    ticketDragEnd(widget: CustomTicketWidgetItem) {
        this.gb.DraggedTicket = null;
        $('.TicketWidget' + widget.TicketID).removeClass('beingDragged');
        $('body').removeClass('draggingTicket');
    }


    isPastDue(myDate: Date): boolean {
        myDate = new Date(myDate);
        if (myDate.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0))
            return true;
        return false;
    }

    UpdateFilterArray() {
        this.TicketFilterArray = [];

        if (this.ShowNew)
            this.TicketFilterArray.push(TicketStatusTypes.New);

        if (this.ShowInProgress)
            this.TicketFilterArray.push(TicketStatusTypes.InProgress);

        if (this.ShowAwaitingAdmin)
            this.TicketFilterArray.push(TicketStatusTypes.AwaitingAdminResponse);

        if (this.ShowAwaitingMember)
            this.TicketFilterArray.push(TicketStatusTypes.AwaitingMemberResponse);

        if (this.ShowTOS)
            this.TicketFilterArray.push(TicketStatusTypes.TOS);

        if (this.ShowClosed)
            this.TicketFilterArray.push(TicketStatusTypes.Closed);
    }


    SetListView(newIsListView: boolean) {
        this.isListView = newIsListView;
        this.ListViewChanged.emit(this.isListView);
    }

    async SetClosedFilter(newClosedState: boolean){
        this.ShowClosed = newClosedState;
        this.onClosedFilterChanged.emit(newClosedState);
        if (this.DynamicallyLoadClosed && this.ShowClosed && !this.EverShowClosed){
            //We are Showing closed for the first time, and need to dynamically load data
            this.IsBusy = true;

            let request = CustomTicketsWidgetsSearchRequest.GetEmptySearch();
            request.AdminID = this.AdminID;
            request.Status = new Array<TicketStatusTypes>();
            request.Status.push(TicketStatusTypes.Closed);
    
            if (this.SelectedDateSearchOption == 0) {
                request.StartDateTimeCreated = this.StartDate;
                request.EndDateTimeCreated = this.EndDate;
            } else {
                request.StartDueDate = this.StartDate;
                request.EndDueDate = this.EndDate;
            }

            await this.api.CustomTicketsSeachWidgets(request).toPromise().then(
                response => {
                    var closedTickets = response.Data;
                    
                    closedTickets.forEach(t => {
                        this.Widgets.push(t);        
                    });

                    this.UpdateFilterArray();

                    this.IsBusy = false;
                }
            ).catch(error => { console.log('ERROR', error) });

            //Only once
            this.EverShowClosed = true;
        }
    }

    ShortenedAdminName(name: string): string {
        if (name == '(not assigned)') return name;
        return name.split(' ')[0] + ' ' + name.split(' ')[1].split('')[0];
    }


    ReloadClick() {
        this.onRefresh.emit(true);
    }
}
